import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CAMPAIGN_ACTIONS_PAGE_CONFIG = defineFcm('campaign_actions_page_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				activatedPercentage: { type: 'number' },
				specificPetitions: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							id: { type: 'number' },
						},
					},
				},
				blocklist: {
					optional: true,
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							id: { type: 'number' },
						},
					},
				},
				supportedLocales: {
					optional: true,
					type: 'array',
					shape: { type: 'string' },
				},
				isUploadEnabled: {
					optional: true,
					type: 'boolean',
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		activatedPercentage: 0,
		specificPetitions: [],
		blocklist: [],
		supportedLocales: [],
		isUploadEnabled: false,
	})
	.toConfig();
